import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'app-need-help-modal',
  imports: [CommonModule],
  templateUrl: './need-help-modal.component.html',
  styleUrl: './need-help-modal.component.scss'
})
export class NeedHelpModalComponent {

}
